/**
 * Cognito Hosted UI config for federated sign-in (e.g. Google SSO).
 */
const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN || 'hat-server';

const AWS_REGION = process.env.REACT_APP_AWS_REGION || 'us-east-1';

export const cognitoHostedUIBase = `https://${COGNITO_DOMAIN}.auth.${AWS_REGION}.amazoncognito.com`;

/** Optional `registrationCode` is for flows that need PreSignUp validation; sign-in omits it. */
export function getGoogleSignInUrl(
  clientId,
  redirectUri,
  registrationCode,
  prompt = 'select_account'
) {
  const redirect = redirectUri || `${window.location.origin}/auth/callback`;
  const params = new URLSearchParams({
    identity_provider: 'Google',
    response_type: 'token',
    client_id: clientId,
    redirect_uri: redirect,
    // Scopes must be enabled on the Cognito app client; custom attributes are NOT valid OAuth scopes.
    // `profile` is required for the id_token to include given_name / name claims.
    scope: 'openid email profile',
    prompt: 'select_account',
  });

  // Pass registration/invite code to Cognito's PreSignUp_ExternalProvider trigger.
  // The Cognito Lambda reads it from `event.request.validationData.registrationCode`.
  if (registrationCode) params.set('registrationCode', registrationCode);
  if (prompt) params.set('prompt', prompt);

  return `${cognitoHostedUIBase}/oauth2/authorize?${params.toString()}`;
}

export function getCognitoSignOutUrl(clientId, logoutUri) {
  const redirect = logoutUri || `${window.location.origin}/login`;
  const params = new URLSearchParams({
    client_id: clientId,
    logout_uri: redirect,
  });
  return `${cognitoHostedUIBase}/logout?${params.toString()}`;
}

/** Google OAuth helper; optional state can be passed when needed. */
export function getGoogleOAuthUrl(
  clientId,
  redirectUri,
  state = '',
  prompt = 'select_account'
) {
  const params = new URLSearchParams({
    identity_provider: 'Google',
    response_type: 'token',
    client_id: clientId,
    redirect_uri: redirectUri,
    // Scopes must be enabled on the Cognito app client; custom attributes are NOT valid OAuth scopes.
    // `profile` is required for the id_token to include given_name / name claims.
    scope: 'openid email profile',
    prompt: 'select_account',
  });
  if (state) params.set('state', state);
  if (prompt) params.set('prompt', prompt);
  return `${cognitoHostedUIBase}/oauth2/authorize?${params.toString()}`;
}
